import { render, staticRenderFns } from "./ScreeningQuestionRenderer.vue?vue&type=template&id=ef1d6fc2"
import script from "./ScreeningQuestionRenderer.vue?vue&type=script&lang=js"
export * from "./ScreeningQuestionRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports